<template>
 <div class="registerContent">
     <div class="register">
       <div class="registerTitle">用户注册</div>
       <div class="registerUserName"><input type="text" placeholder="请输入手机号码" v-model.trim="form.name"></div>
       <div class="registerPassword">
        <input :type="passwordType" placeholder="请输入数字、字母、特殊字符组合密码" v-model.trim="form.password">
        <img v-if="passwordType === 'password'" src="https://file-sz.fjjykj.com.cn/Supply/se21a0a57445b47f30e25aa15ddae8d94.png" @click="handlePassword">
        <img v-else src="https://file-sz.fjjykj.com.cn/Supply/s863608c680ccd0900caff867a42cf508.png" @click="handlePassword">      
       </div>
       <div class="registerConfirmPassword">
        <input type="password" placeholder="请输入确认密码" v-model.trim="form.password_confirmation" @keyup.enter="submitForm"></div>
       <div class="registerCode"><input type="text" placeholder="请输入验证码" v-model.trim="form.code"><img :src="codeUrl"><div @click="refreshCaptcha">刷新</div></div>
       <div class="registerShortMsgCode">
        <input class="shortMsgCode" type="text" placeholder="请输入短信验证码" v-model.trim="form.shortMsgCode">     
        <div class="sendbtn" v-if="!isSendMsg" @click="toSendMsg"> {{shortMsgCodeContent}}</div>   
        <div class="sendbtn1" v-else> {{shortMsgCodeContent}}({{countDown}})</div>   
      </div>
       <div class="registerBtn">
         <input type="button" value="立即注册" @click="submitForm">
       </div>
       <div class="registerRegister">已有账号？<span @click="toLogin">立即登陆</span></div>
     </div>
  </div>
</template>
<style>
@import '../../styles/register.css';
</style>
<script>
import { getCaptchaImage } from '@/api/login'
import api from '@/api'
import c from '@/common/js'
export default {
  name: 'userRegister',
  components: {  },
  data() {
    return {
      codeUrl:'',
      passwordType:'password',
      form: {  // 用户注册信息
        name: '',
        password: '',
        password_confirmation: '',  
        code:'',      
        uniqueCode:'',
        shortMsgCode:'',
        protocol: true,
      },
      shortMsgCodeContent:'获取验证码',
      isSendMsg:false,
      countDown:0,
    }
  },
  created() {
    this.refreshCaptcha()
  },
  mounted() {  
  },
  methods: {   
    toLogin() {
      this.$router.push({ name: 'userLogin' })
    },
    handlePassword() {
      this.passwordType === 'password'
        ? (this.passwordType = '')
        : (this.passwordType = 'password')    
    },
    toSendMsg()
    {
      if (!this.form.name) {    
        this.$message.error('手机号码不能为空!')
        return
      }  
      var myreg=/^[1][3,4,5,7,8,9][0-9]{9}$/;
      if(!myreg.test(this.form.name))
      {
        this.$message({ message: '手机号码格式不正确', type: 'error', customClass: 'c-msg' })
        return;
      }       
      if(this.isSendMsg)return;
      var _this=this;
      api.post('/api/TokenAuth/SendMsg', { mobile:this.form.name }).then(response => {
        debugger
          if(response.data.success)
          {
            _this.isSendMsg=true;     
            _this.shortMsgCodeContent = '重新获取';  
            _this.countDown = 60;
            _this.countDownFun();
          }
          else
          {
            _this.$message({  message: response.data.error.message,type: 'error', customClass: 'c-msg',duration: 0, showClose: true })
          }
      }).catch(error => {     
        debugger;
        const { response, message } = error
        var msg = '抱歉，服务器开了个小差!';
        _this.$message({  message: msg,type: 'error', customClass: 'c-msg',duration: 0, showClose: true })
      })
      
    },
    countDownFun()
      {      
        if(this.countDown>0)
        {
           this.countDown--;          
           var _this=this;          
           setTimeout(() => {
              _this.countDownFun()
            }, 1000)
        }
        else 
        {
           this.isSendMsg=false;     
           this.shortMsgCodeContent = '获取验证码';
           return;
        }   
      }, 
    refreshCaptcha()
    {
      getCaptchaImage().then(response => {
          this.codeUrl ="data:image/jpg;base64," + response.data.result.image;
          this.form.uniqueCode = response.data.result.guid;
      }).catch(error => {     
        this.$message({
          message: '抱歉，服务器开了个小差！',
          type: 'error',
          customClass: 'c-msg',
          duration: 0,
          showClose: true
        })
        Promise.reject(error)
      })
    },
    // 提交表单
    submitForm() {   
      if (!this.form.name) {    
        this.$message.error('手机号码不能为空!')
        return
      }     
      var myreg=/^[1][3,4,5,7,8,9][0-9]{9}$/;
      if(!myreg.test(this.form.name))
      {
        this.$message({ message: '手机号码格式不正确', type: 'error', customClass: 'c-msg' })
        return;
      }          
      if(!this.form.password || !this.form.password_confirmation)
      {
        this.$message.error(((!this.form.password)?'':'确认') + '密码不能为空!')
        return
      }
      var txt = this.form.password;//输入框内容 trim处理两端空格
      var len = txt.length;
      var num = /\d/.test(txt);//匹配数字
      var big = /[A-Za-z]/.test(txt);//大小写字母
      var corps = /\W/.test(txt);//特殊符号
      var val = num + big + corps; //三个组合
      if(len < 6) { 
        this.$message({ message: '密码长度至少需要6位数', type: 'error', customClass: 'c-msg' })
        return;
      }
      if(val != 3) {
        this.$message({ message: '密码强度太低,需要数字、字母、特殊字符中三个的组合', type: 'error', customClass: 'c-msg' })
        return;
      }
      if (!this.form.code) {    
        this.$message.error('验证码不能为空!')
        return
      }     

      if (this.form.password !== this.form.password_confirmation) {
        this.$message.error('两次输入的密码不相同!')
        return
      }     
      if(!this.form.shortMsgCode)
      {
        this.$message.error('短信验证码不能为空!')
      }
      let data = {
        'password': this.form.password,
      }
      // 判断用户是用 name 或 手机 登录的
     
      data.userNameOrEmailAddress = this.form.name
      data.code = this.form.code;
      data.uniqueCode = this.form.uniqueCode;
      data.shortMsgCode = this.form.shortMsgCode;
      api.post('/api/TokenAuth/MemberRegister', data).then(response => {    
        debugger;
        // 如果用户名含有非法字符
        if (!response.data.success) {
            this.$message({
              message: response.data.error.message,
              type: 'error',
              customClass: 'c-msg',
              showClose: true
            })
          
        } else  {
          // 注册成功 
          this.$message({message: '注册成功！', type: 'success', customClass: 'c-msg', duration: 0, showClose: true})
          this.toLogin();
        } 
      }).catch(error => {
       debugger
        this.$message({message: '抱歉，服务器开了个小差！', type: 'error', customClass: 'c-msg', duration: 0, showClose: true})
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Register.vue?93ad13e6